import type { TooltipProps } from "recharts";
import { Box, Flex, Text } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import { useMemo } from "react";
import { removeObjDuplicateBy } from "@/features/dashboard/utils";

// TValue=number, TName=string
export const CustomTooltip: React.FC<TooltipProps<number, string>> = ({
  active,
  payload,
  label,
}) => {
  const uniquePayload = useMemo(
    () =>
      removeObjDuplicateBy(payload ?? [], "dataKey")
        .filter((item) => (item.dataKey as string)?.includes("_solid"))
        .map((item) => ({
          ...item,
          name: (item.dataKey as string)?.replace("_solid", ""),
        })),
    [payload]
  );
  if (!active || !payload || payload.length === 0) return null;

  return (
    <Flex
      flexDirection={"column"}
      gap={"8px"}
      background={"#363636"}
      paddingX={"12px"}
      paddingY={"8px"}
      borderRadius={"8px"}
    >
      <Text textStyle={"body-sm-bold"} color={"#FFFFFF"}>
        {label}
      </Text>
      <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {uniquePayload.map((entry) => {
          const roundedValue = Math.round(entry.value ?? 0);
          const isValueZero = roundedValue === 0;
          return (
            <li
              key={entry.dataKey}
              style={{
                display: "flex",
                alignItems: "center",
                opacity: isValueZero ? 0.5 : 1,
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: 8,
                  height: 8,
                  backgroundColor: entry.color, // dot 컬러
                  borderRadius: "50%",
                  marginRight: 6,
                }}
              />

              <Flex justifyContent={"space-between"} width={"100%"} gap={"8px"}>
                <Text textStyle={"body-sm-medium"} color={"#FFFFFF"}>
                  {entry.name}
                </Text>
                <Text textStyle={"body-sm-bold"} color={"#FFFFFF"}>
                  {isValueZero ? "-" : roundedValue}%
                </Text>
              </Flex>
            </li>
          );
        })}
      </ul>
      <Flex gap={"4px"} color={"#FFFFFF"}>
        <SVG src={"/icons-v1_1/info.svg"} width={16} height={16} />
        <Text textStyle={"caption-regular"}>
          ‘-’ 표시 : 해당 시즌 데이터 없음
        </Text>
      </Flex>
    </Flex>
  );
};
